import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useLocation, Link } from 'react-router-dom';

export default function FloatingCart() {
  const { totalItems, isOpen } = useCart();
  const location = useLocation();

  // Hide on checkout page, when cart drawer is open, or when no items
  if (location.pathname === '/checkout' || isOpen || totalItems === 0) {
    return null;
  }

  return (
    <Link 
      to="/checkout"
      className="fixed bottom-24 right-6 z-30 bg-gold hover:bg-gold-light text-black w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110"
      data-testid="floating-cart"
      aria-label="Idi na checkout"
    >
      <div className="relative">
        <ShoppingBag size={24} />
        <span className="absolute -top-2 -right-2 bg-black text-gold text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
          {totalItems}
        </span>
      </div>
    </Link>
  );
}
